// Sozlama qiymatini ko'rsatish (katalogdagi turga qarab)
import type { SettingDef, SettingLevel } from '@onepos/shared';
import type { Tone } from '@onepos/ui';

export const LEVEL: Record<SettingLevel, { label: string; tone: Tone; hint: string }> = {
  oddiy: { label: 'Oddiy', tone: 'neutral', hint: 'Ega darhol o‘zgartiradi' },
  muhim: { label: 'Muhim', tone: 'warning', hint: 'Ega tasdiq bilan o‘zgartiradi' },
  tizimli: { label: 'Tizimli', tone: 'danger', hint: 'Faqat platforma o‘zgartiradi' },
};

export const EFFECT: Record<SettingDef['effect'], string> = {
  immediate: 'darhol',
  next_shift: 'keyingi smenadan',
  next_business_day: 'ertangi ish kunidan',
};

export function settingValueText(def: SettingDef, value: unknown): string {
  switch (def.type) {
    case 'boolean':
      return value === true ? 'Ha' : 'Yo‘q';
    case 'enum':
      return def.options.find((o) => o.value === value)?.label ?? String(value);
    case 'multi':
      return Array.isArray(value)
        ? value.map((v) => def.options.find((o) => o.value === v)?.label ?? String(v)).join(', ')
        : '—';
    case 'number':
      return typeof value === 'number' ? String(value) : '—';
    case 'text': {
      if (typeof value !== 'string' || !value) return '(bo‘sh)';
      // Chek rasmlari (Q-068): uzun kod o'rniga — o'lchami
      const img = /^mb1:(\d+)x(\d+):/.exec(value);
      if (img) return `Rasm, ${img[1]}×${img[2]} nuqta`;
      return value.length > 200 ? `${value.slice(0, 200)}…` : value;
    }
    case 'time':
      return typeof value === 'string' ? value : '—';
  }
}
